<template>
  <j-modal
    :title="title"
    :width="width"
    :visible="visible"
    :confirmLoading="confirmLoading"
    switchFullscreen
    @ok="handleOk"
    @cancel="handleCancel"
    cancelText="关闭"
  >
    <a-spin :spinning="confirmLoading">
      <a-form :form="form">
        <a-form-item
          label="卡券名称"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-input
            type="text"
            :max-length="10"
            v-decorator="[
              'name',
              {
                rules: [
                  { required: true, message: '请输入卡券名称(限制10个字)' }
                ]
              }
            ]"
            placeholder="请输入卡券名称"
          ></a-input>
        </a-form-item>
        <!--<a-form-item label="卡券面值" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="['faceValue', { rules: [{ required: true, message: '请输入卡券面值' }] }]" placeholder="请输入卡券面值"></a-input>
        </a-form-item>-->
        <a-form-item label="卡号" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input
            type="text"
            :max-length="50"
            v-decorator="[
              'accountNum',
              { rules: [{ required: true, message: '请输入卡券帐号' }] }
            ]"
            placeholder="请输入卡号"
          ></a-input>
        </a-form-item>
        <a-form-item label="卡密" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input
            type="text"
            :max-length="50"
            v-decorator="[
              'cami',
              { rules: [{ required: true, message: '请输入卡券密码' }] }
            ]"
            placeholder="请输入卡密"
          ></a-input>
        </a-form-item>
        <a-form-item
          label="有效截止日期"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-date-picker
            format="YYYY-MM-DD HH:mm:ss"
            :disabled-date="disabledDate"
            :show-time="{ defaultValue: moment('00:00:00', 'HH:mm:ss') }"
            v-decorator="[
              'deadline',
              { rules: [{ required: true, message: '请选择有效截止日期' }] }
            ]"
            style="width: 100%"
          />
        </a-form-item>
      </a-form>
    </a-spin>
  </j-modal>
</template>

<script>
import { httpAction } from '@/api/manage';
import pick from 'lodash.pick';
import { validateDuplicateValue } from '@/utils/util';
import JDate from '@/components/jeecg/JDate';
import JDisabledDate from '@/components/jeecg/JDisabledDate';
import moment from 'moment';
import 'moment/locale/zh-cn';

export default {
  name: 'CardTicketModal',
  components: {
    JDate,
    JDisabledDate
  },
  data() {
    return {
      form: this.$form.createForm(this),
      title: '操作',
      width: 800,
      visible: false,
      model: {},
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },
      confirmLoading: false,
      validatorRules: {},
      url: {
        add: process.env.VUE_APP_CMS_MARKETING + '/cardTicket/add',
        edit: process.env.VUE_APP_CMS_MARKETING + '/cardTicket/edit'
      }
    };
  },
  created() {},
  methods: {
    moment,
    add() {
      this.edit({});
    },
    edit(record) {
      this.form.resetFields();
      this.model = Object.assign({}, record);
      this.visible = true;
      if (this.model.deadline) {
        this.model.deadline = moment(
          this.model.deadline,
          'YYYY-MM-DD HH:mm:ss'
        );
      }
      this.$nextTick(() => {
        this.form.setFieldsValue(
          pick(this.model, 'name', 'accountNum', 'cami', 'deadline')
        );
      });
    },
    close() {
      this.$emit('close');
      this.visible = false;
    },
    handleOk() {
      const that = this;
      // 触发表单验证
      this.form.validateFields((err, values) => {
        if (!err) {
          that.confirmLoading = true;
          let httpurl = '';
          let method = '';
          if (!this.model.id) {
            httpurl += this.url.add;
            method = 'post';
          } else {
            httpurl += this.url.edit;
            method = 'post';
          }
          let formData = Object.assign(this.model, values);
          formData.deadline = formData.deadline.format('YYYY-MM-DD HH:mm:ss');
          httpAction(httpurl, formData, method)
            .then(res => {
              if (res.success) {
                that.$message.success(res.message);
                that.$emit('ok');
              } else {
                that.$message.warning(res.message);
              }
            })
            .finally(() => {
              that.confirmLoading = false;
              that.close();
            });
        }
      });
    },
    handleCancel() {
      this.close();
    },
    popupCallback(row) {
      this.form.setFieldsValue(
        pick(
          row,
          'createTime',
          'name',
          'accountNum',
          'cami',
          'deadline',
          'status'
        )
      );
    },

    disabledDate(current) {
      //return current && current < moment().endOf('day');//当天之前的不可选，包括当天
      return current && current < moment().subtract(1, 'days'); //当天之前的不可选，不包括当天
    }

    /*  disabledDateTime() {
        return {
          disabledHours: () => this.range(0, 24).splice(4, 20),
          disabledMinutes: () => this.range(30, 60),
          disabledSeconds: () => [55, 56],
        };
      },
      range(start, end) {
        const result = [];
        for (let i = start; i < end; i++) {
          result.push(i);
        }
        return result;
      },
*/
  }
};
</script>
